export default function TeamSearchInput({ value = "", onChange, placeholder = "Tìm tên đội bóng...", className = "" }) {
  return (
    <div className={`w-full ${className}`}>
      <input
        type="search"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        className="w-full px-3 py-2 rounded-lg text-sm border border-[var(--theme-border,#e5e7eb)] bg-[var(--theme-bg,#fff)] text-[var(--theme-text,#111)] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[var(--theme-primary,#3b82f6)]/20"
      />
    </div>
  );
}
